import React, {useEffect, useState} from "react"
import { Link } from 'react-router-dom'
import API from './custom/API'
import SettingForm from "./forms/SettingForm"
import SettingShortcodes from "./SettingShortcodes"
import Loading from "./custom/Loading"

const Settings = () => {
    const [showLoading, setShowLoading] = useState(false)
    const [fields, setFields] = useState({})
    const [sections, setSections] = useState({})
    const [activeMenu, setActiveMenu] = useState('general')
    const [shortcodes, setShortcodes] = useState({})

    const menuClick = (e) => {
        setActiveMenu(e.target.value)
    }

    const getSettingsData = () => {
        setShowLoading(true)
        API.get('wpcb/setting_fields')
        .then(res => {
            let data = res.data
            setFields(data.fields)
            setSections(data.labels)
            setShortcodes(data.shortcodes)
            setShowLoading(false)
        })
        .catch(err => {
            console.log('Error in retrieving setting fields')
            console.log(err)
            setShowLoading(false)
        })
    }

    useEffect(() => {
        setShowLoading(true)
        getSettingsData()
    }, [])
    return (
        <>
        <Loading isVisible={showLoading} />
		<div>
            <div className="row">
                <div className='col-12 col-md-2'>
                    <div className="card card-body bg-light h-100 min-vh-100 m-0 border-bottom border-light shadow rounded-0 p-0">
                        {Object.keys(sections)?.map((key, idx) => {
                            return <div key={idx}>
                                <button 
                                    className={"w-100 h6 m-0 p-3 border rounded-0 nav-link btn-outline-secondary "+(activeMenu == key ? 'bg-secondary text-white' : '')}
                                    value={key}
                                    onClick={(e) => menuClick(e)}
                                >
                                    {sections[key]}
                                </button>
                            </div>
                        })}
                    </div>
                </div>
                <div className='col-12 col-md-10'>
                    {Object.keys(fields)?.map((key, idx) => {    
                        return <div className={'row '+(activeMenu == key ? '' : 'd-none')} key={idx}>
                            <div className='col-12 col-md-6'>
                                <SettingForm formData={fields[key]} setting={key} getSettingsData={getSettingsData} setShowLoading={setShowLoading}/>
                            </div>
                            <div className='col-12 col-md-6'>
                                <div className={key == 'general' ? '' : 'd-none'}>
                                    <div className="card border-0 shadow pb-4 pt-2">
                                        <h4 className="h4">Our Services</h4>
                                        {/* Web Development */}
                                        <div className="border border-info p-3 rounded">
                                            <h6 className="h6 text-info">Web Development</h6>
                                            <p className="m-0">We offer comprehensive web development services that are tailored to meet the unique need of your business.</p>
                                        </div>

                                        {/* Plugin Development */}
                                        <div className="border border-info p-3 rounded mt-3">
                                            <h6 className="h6 text-info">Plugin Development</h6>
                                            <p className="m-0">
                                                We have a competent WordPress plugin developer team with years of experience. 
                                                Our team understands the bespoke client requisites to formulate a well-planned WordPress plugin development strategy from ideation to its execution and seamless integration with the website.
                                            </p>
                                        </div>

                                        {/* System Development */}
                                        <div className="border border-info p-3 rounded mt-3">
                                            <h6 className="h6 text-info">System Development</h6>
                                            <p className="m-0">We build applications to help your business become more efficient, innovative, and successful by providing solutions that are customized to your specific needs and challenges.</p>
                                        </div>
                                    </div>

                                    {/* Demo */}
                                    <div className="card border-0 shadow pb-4 pt-2">
                                        <h4 className="h4 mb-3">Website & Contacts</h4>
                                        <p className="mb-2">Demo: <a href="https://wpshiptrack.com/demo/booking/">wpshiptrack.com/demo/booking</a></p>
                                        <p className="mb-2">Skype: <a href="https://join.skype.com/invite/qewWsgXncsLk">Booking Calendy</a></p>
                                        <p className="mb-2">Email: <a href="mailto:bookingcalendy@gmail.com">bookingcalendy@gmail.com</a></p>
                                    </div>
                                </div>
                                <SettingShortcodes shortcodes={shortcodes} className={['email_client', 'email_admin'].includes(key) ? '' : 'd-none'} />
                            </div>
                        </div>              
                    })}
                </div>
            </div>
        </div>
		</>
    )
}
export default Settings